import { PopupManager } from 'element-ui/src/utils/popup/index'
import Vue from 'vue'
import pgNotificationComponent from './src/notification.vue'

const pgNotificationConstructor = Vue.extend(pgNotificationComponent)
let instances = []
let seed = 1
let task = []

function notification({ options, id }) {
  const instance = new pgNotificationConstructor()
  instance.id = id
  const props = {
    ...options,
    close() {
      pgNotification.close(instance.id)
    },
    onAfterEnter() {
      task.shift()
      notification.run()
    },
  }
  const oldDom = instances.length > 0 ? instances[instances.length - 1].$el : null
  const oldTop = oldDom ? oldDom.offsetHeight + oldDom.offsetTop : 0
  instance.yOffset = oldTop + (props?.offset ?? 0) + 16
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.show(props)
  instance.$el.style.zIndex = PopupManager.nextZIndex()
  instances.push(instance)
  return instance
}

notification.run = function () {
  if (task.length === 0) return
  const [options] = task
  notification(options)
}

export function pgNotification(options) {
  const id = `notification_${seed++}`
  task.push({
    options,
    id,
  })
  if (task.length === 1) {
    notification.run()
  }
  return {
    close() {
      const instance = instances.find((im) => im.id === id)
      instance?.onClose?.()
    },
  }
}
pgNotification.close = function (id) {
  const index = instances.findIndex((im) => im.id === id)
  if (instances.length > index + 1) {
    for (let i = index + 1; i < instances.length; i++) {
      instances[i].yOffset = instances[i].yOffset - instances[index].$el.offsetHeight - 16
    }
  }
  instances.splice(index, 1)
}

pgNotification.closeAll = function () {
  for (let item of instances) {
    item.onClose()
  }
}
